import { Button, ButtonProps, makeStyles } from "@material-ui/core";
import { ITheme, colours } from "../constants/theme";

const useStyles = makeStyles((theme: ITheme) => ({
  button: {
    background: colours.highEmphasis,
    color: theme.palette.primary.main,
    borderRadius: 8,
    "&:hover": {
      backgroundColor: colours.highEmpasis008,
    },
    "&:active": {
      backgroundColor: colours.highEmpasis24,
    },
  },
}));
export function ButtonPrimary({
  onClick,
  startIcon,
  className,
  ...rest
}: ButtonProps) {
  const classes = useStyles();
  const combinedClasses = className
    ? `${classes.button} ${className}`
    : classes.button;
  return (
    <Button
      variant="contained"
      color="primary"
      disableElevation
      className={combinedClasses}
      startIcon={startIcon}
      onClick={onClick}
      {...rest}
    >
      {rest.children}
    </Button>
  );
}

export default ButtonPrimary;
